module.exports = __webpack_public_path__ + "images/flags_new-f8fe45069044c46d57a6772a1e86bda9.png";